import Vue from 'vue';

Vue.component('gallery', () => import('../../node_modules/vue-gallery/dist/js/vue-gallery.min'));
